import React, {useEffect} from 'react';
import GraphicUtils from "../../../../../../utils/graphic-utils.js";
import ReportUtils from "../../../../../../utils/report-utils.js";

const reportName = "Abordagens por tipo de veículos"
const VehiclesTypes = ({data}) => {

  useEffect(() => {
    const values = data.map(i => i.qty);
    const labels = data.map(i => i.vehicles);

    GraphicUtils.barChart('vehicles-type', values, labels, false);
    data.length > 0 && ReportUtils.createExportableTable(labels, values, reportName);
  }, [data]);

  return (
    <>
      <div className="chart-report">
        <span className="chart-title">{reportName}</span>
        <div className="mt-3" id="vehicles-type"></div>
      </div>

      <div className="chart-divisor"></div>
    </>
  );
};

export default VehiclesTypes;